import axios from '@/api/config';

const chapterMaterialsKnowledge = {
    getChapterKnowledgeByChapterId(data) {
        return axios.get(`${process.env.BASE_URL}/chapterMaterialsKnowledge/getChapterKnowledgeByChapterId`,  {params:data});
    },
    addDefaultChapterMaterials(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterialsKnowledge/addDefaultChapterMaterials`,  data);
    },
    batchAddKnowledgeForChapterMaterials(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterialsKnowledge/batchAddKnowledgeForChapterMaterials`,  data);
    },
    batchUpdateKnowledgeForChapterMaterials(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterialsKnowledge/batchUpdateKnowledgeForChapterMaterials`,  data);
    },
    getChapterMaterialsKnowledgeList(data) {
        return axios.get(`${process.env.BASE_URL}/chapterMaterialsKnowledge/getChapterMaterialsKnowledgeList`,  {params: data});
    },
}

export default chapterMaterialsKnowledge;



// WEBPACK FOOTER //
// ./src/api/chapterMaterialsKnowledge.js